import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageManagementService } from 'src/service/language-management.service';
import { LocalService, ReceiptType } from 'src/service/local.service';

@Component({
  selector: 'app-receipt-options-html-content',
  templateUrl: './receipt-options-html-content.component.html',
  styleUrl: './receipt-options-html-content.component.scss'
})
export class ReceiptOptionsHtmlContentComponent {
  lstSectionConfigKeys: string[] = ["seller", "common"];

  businessId: string | undefined = undefined; receiptType: ReceiptType = ReceiptType.None;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.businessId = routeParams.businessId;
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, this.businessId);
      this.receiptType = routeParams.receiptType;
    });
  }
}
